var render = function render(){var _vm=this,_c=_vm._self._c;return _c('company-form',{attrs:{"showDeleteButton":false,"isSubmitting":_vm.isSubmitting},on:{"submit":_vm.onSubmit}})
}
var staticRenderFns = []

export { render, staticRenderFns }